import { render } from "./Story.vue?vue&type=template&id=8d2d86aa&scoped=true"
import script from "./Story.vue?vue&type=script&lang=js"
export * from "./Story.vue?vue&type=script&lang=js"

import "./Story.vue?vue&type=style&index=0&id=8d2d86aa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8d2d86aa"
/* hot reload */
if (module.hot) {
  script.__hmrId = "8d2d86aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8d2d86aa', script)) {
    api.reload('8d2d86aa', script)
  }
  
  module.hot.accept("./Story.vue?vue&type=template&id=8d2d86aa&scoped=true", () => {
    api.rerender('8d2d86aa', render)
  })

}

script.__file = "src/views/Story.vue"

export default script